// 只能输入数字
export function isPhoneNumberValid(str: string) {
  const phoneNumber = str.startsWith('+') ? str.split(' ').slice(1).join(' ') : str;
  return /^[0-9]*$/.test(phoneNumber);
}
